/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_DescriptionInputs */

const en_gc_resources_guide_analysis_description = /** @type {(inputs: Gc_Resources_Guide_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare a small data table, then explore charts and PivotTables in the desktop app.`)
};

const zh_gc_resources_guide_analysis_description = /** @type {(inputs: Gc_Resources_Guide_Analysis_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整理一张小数据表，在桌面应用中探索图表和数据透视表。`)
};

/**
* | output |
* | --- |
* | "Prepare a small data table, then explore charts and PivotTables in the desktop app." |
*
* @param {Gc_Resources_Guide_Analysis_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_description = /** @type {((inputs?: Gc_Resources_Guide_Analysis_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_description(inputs)
	return zh_gc_resources_guide_analysis_description(inputs)
});
export { gc_resources_guide_analysis_description as "gc.resources.guide.analysis.description" }